export const TAG_SUGGESTIONS = ["TAF Guest", "Repeater", "Owner", "Local", "VIP", "Birthday"];

export const TAG_STYLE = {
  "TAF Guest": "bg-brand/15 text-brand-700 ring-brand/30",
  Repeater: "bg-sea/15 text-sea-600 ring-sea/30",
  Owner: "bg-purple-100 text-purple-700 ring-purple-300",
  Local: "bg-sage/15 text-sage-600 ring-sage/30",
  VIP: "bg-amber-100 text-amber-700 ring-amber-300",
  Birthday: "bg-pink-100 text-pink-700 ring-pink-300",
};

export const TagChips = ({ tags, className = "" }) => {
  if (!tags || tags.length === 0) return null;
  return (
    <div className={`flex flex-wrap gap-1 ${className}`} data-testid="tag-chips">
      {tags.map((t) => (
        <span
          key={t}
          className={`rounded-full px-1.5 py-0.5 text-[10px] font-semibold leading-none ring-1 ${TAG_STYLE[t] || "bg-slate-100 text-slate-600 ring-slate-300"}`}
        >
          {t}
        </span>
      ))}
    </div>
  );
};
